import styled from 'styled-components'

export const StyledInjuryChildContainer = styled.div`
  ${({ visible }) => !visible && `
    display: none;
  `}

  padding: 0 15px;
`
